import React from 'react';
export function CommunityGift() {
  return <section className="bg-blush py-24 md:py-32" data-id="element-67">
      <div className="max-w-[1180px] mx-auto px-6" data-id="element-68">
        <div className="max-w-3xl mx-auto space-y-8 text-center" data-id="element-69">
          {/* Header */}
          <div className="space-y-4" data-id="element-70">
            <p className="text-xs font-medium tracking-widest uppercase text-muted" data-id="element-71">
              RESURSE GRATUITE
            </p>
            <h2 className="font-serif text-4xl md:text-5xl font-medium text-cyan" data-id="element-72">
              Cadoul meu pentru tine
            </h2>
          </div>

          {/* Content */}
          <div className="space-y-10" data-id="element-73">
            <p className="text-lg leading-relaxed text-navy" data-id="element-74">
              Intră gratuit în comunitatea privată de WhatsApp dedicată femeilor
              aflate în proces de vindecare. Primești exerciții simple, ghidaje
              practice și invitații la sesiuni live de training pe Zoom, cadou
              din partea mea.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-75">
              <a href="https://wa.me/40749574631" target="_blank" rel="noopener noreferrer" className="inline-block bg-magenta text-white font-sans text-[15px] font-semibold rounded-full px-9 py-3.5 hover:bg-cyan transition-colors duration-300 w-full sm:w-auto text-center" data-id="element-76">
                Intră Gratuit în Comunitate
              </a>
              <a href="https://wa.me/40749574631" target="_blank" rel="noopener noreferrer" className="inline-block bg-transparent border-2 border-magenta text-magenta font-sans text-[15px] font-semibold rounded-full px-9 py-3.5 hover:bg-magenta hover:text-white transition-colors duration-300 w-full sm:w-auto text-center" data-id="element-77">
                Rezervă Sesiunea CADOU
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}